import React from 'react';
import { Link } from 'react-router-dom';

const OurStory = () => {
    return (
        <section className="our-story py-80">
            <div className="container container-lg">
                <div className="row gy-4 align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-lg-6">
                        <div className="our-story__image position-relative">
                            <div className="rounded-16 overflow-hidden">
                                <img 
                                    src="assets/images/thumbs/khlie.jpg" 
                                    alt="Notre Histoire" 
                                    className="w-100 h-100 object-fit-cover"
                                />
                            </div>
                            {/* Decorative Badge */}
                           
                        </div>
                    </div>

                    {/* Right Side - Content */}
                    <div className="col-lg-6">
                        <div className="our-story__content">
                            {/* Badge */}
                            <span className="our-story-badge py-8 px-24 rounded-pill text-sm fw-medium d-inline-block mb-16">
                                Notre Histoire
                            </span>
                            
                            {/* Title */}
                            <h2 className="mb-24 mt-16">
                                <span className="our-story-title">Une Tradition Familiale</span>
                                <span className="our-story-subtitle"> Transmise de Génération en Génération</span>
                            </h2>

                            {/* Description Paragraphs */}
                            <div className="mb-32">
                                <p className="text-gray-700 mb-20 text-line-height-loose">
                                    L'histoire de la famille Benkirane commence il y a plusieurs générations avec la création du Khalie et d'autres délices traditionnels fassis. Depuis le grand-père, un passionné de cuisine artisanale, jusqu'à aujourd'hui, chaque membre de la famille a contribué à préserver et enrichir cet héritage culinaire unique.
                                </p>
                                <p className="text-gray-700 mb-20 text-line-height-loose">
                                    Portée par une passion pour l'authenticité et l'excellence, la famille Benkirane s'engage à respecter les traditions tout en offrant des produits d'une qualité irréprochable. Chaque recette, transmise de génération en génération, est préparée avec soin et avec les meilleurs ingrédients, dans le respect des méthodes artisanales.
                                </p>
                                <p className="text-gray-700 text-line-height-loose">
                                    Aujourd'hui, la famille continue de partager avec vous ses trésors culinaires, fière de transmettre l'amour du goût et de la tradition marocaine à travers des produits faits avec passion et savoir-faire.
                                </p>
                            </div>

                            {/* Features List */}
                            <div className="row g-20 mb-32">
                                <div className="col-sm-6">
                                    <div className="flex-align gap-12">
                                        <div className="w-48 h-48 flex-center our-story-icon rounded-circle flex-shrink-0">
                                            <i className="ph-fill ph-check-circle text-2xl"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-4">Recettes Authentiques</h6>
                                            <span className="text-sm text-gray-600">Héritage Fassi</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="flex-align gap-12">
                                        <div className="w-48 h-48 flex-center our-story-icon rounded-circle flex-shrink-0">
                                            <i className="ph-fill ph-check-circle text-2xl"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-4">Qualité Premium</h6>
                                            <span className="text-sm text-gray-600">Ingrédients Sélectionnés</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="flex-align gap-12">
                                        <div className="w-48 h-48 flex-center our-story-icon rounded-circle flex-shrink-0">
                                            <i className="ph-fill ph-check-circle text-2xl"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-4">Fait Main</h6>
                                            <span className="text-sm text-gray-600">Savoir-faire Artisanal</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="flex-align gap-12">
                                        <div className="w-48 h-48 flex-center our-story-icon rounded-circle flex-shrink-0">
                                            <i className="ph-fill ph-check-circle text-2xl"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-4">Passion & Excellence</h6>
                                            <span className="text-sm text-gray-600">Depuis des Générations</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* CTA Button */}
                            <Link 
                                to="/shop" 
                                className="btn our-story-cta-btn d-inline-flex align-items-center rounded-pill gap-8 px-32"
                            >
                                Découvrir Nos Produits
                                <span className="icon text-xl d-flex">
                                    <i className="ph ph-arrow-right"></i>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurStory;

